import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A sticky index of jump links over a scrolling column (knowledge-page design-spec §2, §2.1,
 * §4.3): the Knowledge page's Type index, issue 281. A `nav` named by `label`, each item a
 * `<button data-jump-link>` in accent ink at 500 that hovers `--accent-pale`
 * (`interactions.css`). Unlike `SectionNav` it marks no current item. It sticks to the top of
 * its scroller on the sheet, a line under it; the owner does the scrolling. Labels render as
 * text.
 */
export function JumpLinks({ label, items, onJump }) {
    return (_jsx("nav", { "aria-label": label, "data-jump-links": "", style: {
            position: "sticky",
            top: 0,
            zIndex: 3,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "var(--space-025) var(--space-05)",
            margin: "0 calc(-1 * var(--space-1))",
            padding: "var(--space-1)",
            background: "var(--sheet)",
            borderBottom: "var(--border-hairline) solid var(--line)",
        }, children: items.map((item) => (_jsx("button", { type: "button", "data-jump-link": item.id, onClick: () => onJump(item.id), style: {
                // knowledge-page design-spec §4.3: links 28px tall.
                height: "28px",
                padding: "0 var(--space-1)",
                margin: 0,
                border: "none",
                borderRadius: "var(--radius-control)",
                fontFamily: "var(--font-sans)",
                fontSize: "var(--type-small-size)",
                fontWeight: "var(--type-body-weight-strong)",
                color: "var(--accent)",
                background: "var(--jump-link-bg, transparent)",
                cursor: "pointer",
                transitionProperty: "background-color",
                transitionDuration: "var(--dur-fast)",
                transitionTimingFunction: "var(--ease-out)",
            }, children: item.label }, item.id))) }));
}
